import { render, staticRenderFns } from "./BoHeader.vue?vue&type=template&id=4e621798&scoped=true&"
import script from "./BoHeader.vue?vue&type=script&lang=js&"
export * from "./BoHeader.vue?vue&type=script&lang=js&"
import style0 from "./BoHeader.vue?vue&type=style&index=0&id=4e621798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e621798",
  null
  
)

export default component.exports